module.exports = __webpack_public_path__ + "static/media/corporacionAmerica.af8b90f2.svg";